import React from 'react';

interface GLTFImportNotSupportedModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const GLTFImportNotSupportedModal: React.FC<GLTFImportNotSupportedModalProps> = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <div
        style={{
          background: 'white',
          padding: '20px',
          borderRadius: '8px',
          textAlign: 'center',
        }}
      >
        <p>Fehler: Importieren eines alten Grundrissplans ist aktuell nicht möglich</p>
        <button onClick={onClose} style={{ marginTop: '10px', padding: '8px 16px' }}>
          Schließen
        </button>
      </div>
    </div>
  );
};

export default GLTFImportNotSupportedModal;
